import { api } from '@/api';
import http from '@/js/http';
import { Job, JobCreateFullRequest, JobUpdateRequest } from '@/types';

export const JobService = {
    async create(payload: JobCreateFullRequest) {
        const { data } = await http.post<Job>(`/admin/jobs/create`, payload);
        return data;
    },

    async update(id: string | number, payload: JobUpdateRequest) {
        const { data } = await http.put<Job>(`/jobs/${id}`, payload);
        return data;
    },

    pdf: api('/api/jobs/{jobId}/pdf', 'post'),

    async getById(id: string | number) {
        const { data } = await http.get<Job>(`/jobs/${id}`);
        return data;
    },
};
